import React from 'react';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const SuccessMessage = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        FORGOT_PASSWORD_MESSAGES: { NOTE, CONFIRMATION_MESSAGE }
      }
    }
  } = localizedStrings;
  return (
    <>
      <div
        id="email_sent"
        className="informational_message"
        style={{ marginTop: 15 }}
      >
        <span
          className="frg-icon icon-warning-inverted"
          style={{
            fontSize: 14,
            color: '#66cc00',
            marginRight: 5
          }}
        />
        <span className="frg-body-font-14px">
          <b>{NOTE}</b>: {CONFIRMATION_MESSAGE}
        </span>
      </div>
    </>
  );
};

export default SuccessMessage;
